import { useState } from 'react';
import { useInView } from '@/hooks/useInView';

const awards = [
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/%D0%9B%D1%8C%D0%B2%D0%BE%D0%B2-%D0%90%D1%80%D0%B5%D0%BD%D0%B0.jpg', title: 'Lviv IT Arena 2022', desc: 'Nanit Robot took third place at the Startup Competition and received $15,000. The company develops edtech solutions for children and adults, the goal of which is to develop creativity and engineering skills.', logos: [] },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/%D0%A2%D0%B5%D1%85%D0%BA%D1%80%D0%B0%D0%BD%D1%87.jpg', title: 'TechCrunch Disrupt 2022', desc: 'The Nanit Robot team was presented as one of the companies of the Ukrainian pavilion at TechCrunch Disrupt 2022 in San Francisco.', logos: [] },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/image_2022-08-31_00-54-25.png', title: 'Startup Challenge Toys in Ukraine', desc: 'Among the companies that presented their innovative toy ideas as part of the #ToysStartupChallenge', logos: ['https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/kiddisvit.svg', 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2022/09/unit-city.svg'] },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/image_2022-09-21_19-22-45.jpg', title: 'Nanit Robot at Collision 2022', desc: 'Nanit Robot presented European companies at the Collision 2022 conference. This is the largest IT conference in Canada.', logos: [] },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/%D0%93%D0%BE%D0%93%D0%BB%D0%BE%D0%B1%D0%B0%D0%BB.jpg', title: 'GoGlobalAwards 2022', desc: 'We received an award in the category "Robotics for the home" in Estonia.', logos: [] },
];

export default function AwardsCarousel() {
  const [current, setCurrent] = useState(0);
  const { ref, inView } = useInView();

  const prev = () => setCurrent((c) => (c - 1 + awards.length) % awards.length);
  const next = () => setCurrent((c) => (c + 1) % awards.length);
  const award = awards[current];

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-gray-50 py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Recognition</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne">Awards &amp; Achievements</h2>
        </div>

        <div className={`relative transition-all duration-700 delay-100 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="flex flex-col lg:flex-row items-stretch gap-0 bg-white rounded-3xl overflow-hidden border border-gray-100">
            <div className="w-full lg:w-80 h-56 lg:h-auto flex-shrink-0">
              <img src={award.img} alt={award.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 p-8 lg:p-10 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-yellow-400 rounded-full text-xs font-bold text-gray-900">
                  {String(current + 1).padStart(2, '0')}
                </span>
                <span className="text-xs text-gray-400 font-medium">{awards.length} achievements</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 font-syne">{award.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{award.desc}</p>
              {award.logos.length > 0 && (
                <div className="flex items-center gap-4">
                  {award.logos.map((logo) => (
                    <img key={logo} src={logo} alt="" className="h-7 object-contain" />
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-between mt-6">
            <div className="flex gap-2">
              {awards.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${i === current ? 'w-8 bg-yellow-400' : 'w-3 bg-gray-300'}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button onClick={prev} className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-full cursor-pointer hover:bg-yellow-400 hover:border-yellow-400 transition-colors">
                <i className="ri-arrow-left-s-line text-lg text-gray-700"></i>
              </button>
              <button onClick={next} className="w-10 h-10 flex items-center justify-center bg-white border border-gray-200 rounded-full cursor-pointer hover:bg-yellow-400 hover:border-yellow-400 transition-colors">
                <i className="ri-arrow-right-s-line text-lg text-gray-700"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
